import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { appActions } from '../../../actions';
import PortalApi from '../../../services/PortalApi';

import AdminPageLayout from '../layout';
import ContactForm from './form';

class ContactTagEditPage extends React.PureComponent {
  state = {
    contactTag: null,
  }

  async componentDidMount() {
    this.props.finishLoading();
    await this.loadContactTag();
  }

  loadContactTag = async () => {
    const contactTag = await PortalApi.admin.getContactTag(this.props.match.params.id);
    this.setState({
      contactTag,
    });
  }

  render() {
    const { className } = this.props;

    return (
      <div className={className}>
        <AdminPageLayout>
          <div className="main-content">
            <h1>Update Contact Tag</h1>
            { this.state.contactTag && (
              <ContactForm mode="edit" id={Number(this.props.match.params.id)} contactTagData={this.state.contactTag} />
            ) }
          </div>
        </AdminPageLayout>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  finishLoading: () => dispatch(appActions.finishLoading()),
});

ContactTagEditPage.propTypes = {
  finishLoading: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,

  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
};

const StyledContactTagEditPage = styled(ContactTagEditPage)`
`;

export default connect(
  null,
  mapDispatchToProps,
)(StyledContactTagEditPage);
